<template>
  <div id="app" class="gradient">
    <Navbar/>
 
    <router-view/>  
  </div>
</template>

<script>
	import Navbar from './components/Navbar'

	export default {
		components:{
			Navbar
		}
	}
</script>

<style>
	body, html {
		margin: 0;
		height: 100%;
		background: linear-gradient(90deg, #9f33d5 0%, #517dda 100%);
	}
	
	.ecommerce-searcher .el-input .el-input__inner,
	.ecommerce-result .el-input .el-input__inner,
	.el-autocomplete-suggestion li {
		color: #000000;
		font-size: 15px;
	}

	.el-autocomplete-suggestion li .geo-l {
		color: red;
		line-height: 14px;
		font-size: 13px;
	}

	.el-autocomplete-suggestion li .none-d {
		color: #262626;
		line-height: 34px;
		font-size: 13px;
	}	

	.el-autocomplete-suggestion li .geo-d {
		color: #000000;		 
		font-weight: 500;
		line-height: 34px;
		font-size: 16px;
	}

	.leaflet-control-layers {
		top: 50px;
	}

	.el-input .el-input__suffix {
		color: #000000;
		border-color: #000000;
		opacity: 1;
	}
</style>
